import { Box, Stack, styled } from '@mui/material'

export const CustomTooltipContainer = styled(Stack)(
  ({ theme }) => `
        gap: ${theme.spacing(1)};
        padding: ${theme.spacing(2)};
        background-color: rgba(255, 255, 255, 0.65);
        backdrop-filter: blur(8px);
        font-size: 12px;
        border-radius: 24px;
        box-shadow: 
            0px 1.85px 3.15px 0px #00000014,
            0px 8.15px 6.52px 0px #0000000A,
            0px 20px 13px 0px #0000000A,
            0px 38.52px 25.48px 0px #0000000B;
        color: ${theme.palette.grey['800']};
        width: 360px;
        position: relative;
        border: 1px solid rgba(255, 255, 255, 0.2);
    `,
)

export const CTLine = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const CTColor = styled(Box)(({ color }) => {
  return `
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: ${color};
    flex-shrink: 0;
  `
})

export const CTTitle = styled(Box)`
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 8px;
  text-transform: capitalize;
`

export const CTLeftContent = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`

export const CTLabel = styled(Box)`
  font-size: 12px;
  font-weight: 400;
`

export const CTType = styled(Box)`
  font-size: 10px;
  color: #989898;
`

export const CTValue = styled(Box)`
  font-size: 12px;
  font-weight: 400;
  display: flex;
  gap: 4px;
  align-items: center;
`

export const CTUnit = styled('span')`
  color: #989898;
`

export const CTTotalSection = styled(Box)`
  display: inline-flex;
  justify-content: flex-end;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 4px 8px;
  margin-top: 8px;
  font-size: 12px;
  gap: 4px;
  align-items: center;
`

export const CTAverageSection = styled(Box)`
  display: flex;
  justify-content: center;
  font-size: 10px;
  margin-top: 8px;
  gap: 4px;
  align-items: center;
`

export const CTEstimatedText = styled(Box)(({ theme }) => `
  font-style: italic;
  font-size: 10px;
  color: ${theme.palette.grey[400]};
  margin-left: 4px;
`)

export const AUContainer = styled(Box)(({ theme }) => {
  return `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `
})
